/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { createSelector } from 'reselect'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { Selector } from 'redux-app/types/selectors'
import { ILocalizationState } from 'redux-app/types/localization'

export const getData: Selector<ILocalizationState> = state => state.localization
export const getLang = state => getData(state).lang
export const getLinksValue = state => _get(getData(state), ['links', 'value'], EMPTY_OBJECT)
export const getLinksUpdated = state => _get(getLinksValue(state), ['meta', 'updated'])
export const getLinks = state => getLinksValue(state).links || EMPTY_OBJECT
export const getLocalTexts = state => getData(state).localTexts
export const getLoadedTextsValue = state => _get(getData(state), ['loadedTexts', 'value'], EMPTY_OBJECT)
export const getLoadedTextsUpdated = state => _get(getLoadedTextsValue(state), ['meta', 'updated'])
export const getLoadedTexts = state => _get(getLoadedTextsValue(state), 'texts', EMPTY_OBJECT)
export const isTextsLoading = state => _get(getData(state), ['loadedTexts', 'loading'], false)

export const getCurrentTexts = createSelector(
  getLocalTexts,
  getLoadedTexts,
  getLinks,
  (localTexts, loadedTexts, links) => ({
    ...loadedTexts,
    ...localTexts,
    links,
  }),
)
